module.exports = __webpack_public_path__ + "static/tulsa-a375224a376951edc8631897cc5f834c.png";